import { SortFieldRow } from "./SortFieldRow";
import { DraggableSortGroup } from "./DraggableSortGroup";
import { useSortGroupState } from "./useSortGroupState";
import { SortGroupProps } from "./types";

export const SortGroup = ({
  fieldName,
  sortList,
  setSortList,
  columnsTitleCreator,
  isDraggable = false,
}: SortGroupProps) => {
  const { selectedDirection, handleChange, handleRemove } = useSortGroupState(
    fieldName,
    sortList,
    setSortList,
  );

  if (isDraggable) {
    return (
      <DraggableSortGroup
        fieldName={fieldName}
        selectedDirection={selectedDirection}
        handleChange={handleChange}
        handleRemove={handleRemove}
        columnsTitleCreator={columnsTitleCreator}
      />
    );
  }

  return (
    <div
      className="flex flex-row items-center mt-1 mb-2 gap-2"
      data-testid={`sorting-available-row-${fieldName}`}
    >
      <SortFieldRow
        fieldName={fieldName}
        selectedDirection={selectedDirection}
        onChange={handleChange}
        columnsTitleCreator={columnsTitleCreator}
      />
    </div>
  );
};
